export const GEOLOCATION_GET_USER_LOCATION = 'GEOLOCATION_GET_USER_LOCATION';
export const SET_BOOKING_FORM_VISIBILITY = 'SET_BOOKING_FORM_VISIBILITY';
export const SET_MESSAGE = 'SET_MESSAGE';

export const USER_ACCESS_TOKEN = 'RISTORANTI.IT@@@USER_ACCESS_TOKEN';



// WEBPACK FOOTER //
// ./src/constants.js